var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"m-icon-color",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }